export default "__VITE_ASSET__DDwcHXmQ__"